import type {
  AssessmentClientActionType,
  IAssessmentClientItem,
  IAssessmentClientState,
} from '../../types';

export function reduceSubmittingAssessmentClientState<TItem extends IAssessmentClientItem, TResult>(
  state: IAssessmentClientState<TItem, TResult>,
  action: AssessmentClientActionType<TItem, TResult>,
): IAssessmentClientState<TItem, TResult> {
  if (action.type === 'submission_failed') {
    return { ...state, error: action.message, phase: 'active' };
  }
  if (action.type !== 'answer_accepted') {
    return state;
  }
  const answeredCount = Math.min(state.totalCount, state.answeredCount + 1);
  const hasNextItem = action.nextItem !== null && answeredCount < state.totalCount;
  return {
    ...state,
    answeredCount,
    currentItem: hasNextItem ? action.nextItem : null,
    currentToken: action.token,
    error: null,
    phase: hasNextItem ? 'active' : 'ready_to_complete',
  };
}
